import translations from "../config/translations";

/* @ngInject */
function trans($window, $rootScope) {
  return function (code, replacements = [], quoteLanguage) {
    let language = quoteLanguage || "es";

    if (!quoteLanguage) {
      if ($rootScope.organization) {
        language = $rootScope.organization.settings.appLanguage;
      } else if ($window.navigator.language.split("-")[0] !== "es") {
        language = "en";
      }
    }
    try {
      let translation = translations[code][language];

      if (replacements.length > 0) {
        replacements.forEach((replacement, index) => {
          translation = translation.replace(`__$${index + 1}__`, replacement);
        });
      }

      return translation;
    } catch (e) {
      throw new Error(`${e.message} - ${code}`);
    }
  };
}

export default trans;
